import apiRequest from './apiRequest';

/**
 * builds the TanStack Query options for one apiRequest call. this is the single
 * place that wires the abort signal and the optional body parse, so the same
 * object works with useApiQuery, useApiQueries and queryClient.fetchQuery.
 * @param queryKey - tanstack query key, ideally built by a per-feature key factory
 * @param request - apiRequest options ({ path, params, method, auth, data, ... })
 * @param parse - optional reader applied to the response body inside the queryFn,
 *   for endpoints that report failure in the body instead of the http status. it
 *   must throw on a bad payload so the query lands in isError instead of caching
 *   an empty success
 */
export default function apiQueryOptions({ queryKey, request, parse }) {
  return {
    queryKey,
    queryFn: async ({ signal }) => {
      const body = await apiRequest({ ...request, signal });
      return parse ? parse(body) : body;
    }
  };
}
